Alpine.data("SevenCRMUpsell", (upsellConfig) => ({
    step: 1,
    upsellConfig: upsellConfig,
    loading: false,
    error: null,
    showThankYou: false,
    hasCompletedFlow: false,

    init() {
      this.handlePurchasedParameter();

        // Check if user has already completed the flow
        this.hasCompletedFlow = this.getCompletionStatus();

        if (!this.hasCompletedFlow) {
            this.initUpsellFlow();
        } else {
            this.showThankYou = true;
        }
    },

  handlePurchasedParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const purchasedId = urlParams.get('purchased');

    if (purchasedId) {
      // Find the index of the purchased upsell in the config
      const purchasedIndex = this.upsellConfig.findIndex(id => id === purchasedId);

      if (purchasedIndex !== -1) {
        // Set step to the next upsell after the purchased one
        this.step = purchasedIndex + 2; // +1 for next, +1 because step is 1-indexed

        // If we've gone past all upsells, show thank you
        if (this.step > this.upsellConfig.length) {
          this.showThankYou = true;
          this.markFlowAsCompleted();
        }

        // Clean up the URL by removing the purchased parameter
        this.removeUrlParameter('purchased');
      }
    }
  },

  removeUrlParameter(parameter) {
    const url = new URL(window.location);
    url.searchParams.delete(parameter);
    window.history.replaceState({}, '', url);
  },

    async initUpsellFlow() {
        try {
            const data = await this.apiCall("/api/upsell/init", "GET");

            if (data.canBeInitialized === false) {
                this.showThankYou = true;
                this.markFlowAsCompleted();
            }
        } catch (error) {
            console.error("Error initializing upsell flow:", error);
            this.error = "Failed to initialize upsell flow. Please refresh the page.";
        }
    },

    async takeUpsell(id) {
        const upsellId = this.upsellConfig[id];

        if (!upsellId) {
            console.error("Invalid upsell ID:", id);
            this.error = "Invalid upsell configuration.";
            return;
        }

        this.loading = true;
        this.error = null;

        try {
            const data = await this.apiCall("/api/upsell/take", "POST", {
                upsellId: upsellId,
            });

            this.handleUpsellSuccess(data);
        } catch (error) {
            console.error("Error taking upsell:", error);
            this.error = "Failed to process upsell. Please try again.";
        } finally {
            this.loading = false;
        }
    },

    async apiCall(url, method = "GET", body = null) {
        const config = {
            method,
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        };

        if (body && method !== "GET") {
            config.body = JSON.stringify(body);
        }

        const response = await fetch(url, config);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    },

    handleUpsellSuccess(data) {
        if (data.redirectUrl) {
            window.location.href = data.redirectUrl;
            return;
        }

        this.advanceStep();
    },

    rejectUpsell(id) {
        this.advanceStep();
    },

    advanceStep() {
        this.step++;

        if (this.step > this.upsellConfig.length) {
            this.showThankYou = true;
            this.markFlowAsCompleted();
        }
    },

    markFlowAsCompleted() {
        this.hasCompletedFlow = true;
        // Store completion status (you can choose sessionStorage or localStorage)
        sessionStorage.setItem("sevencrm_upsell_completed", "true");
    },

    getCompletionStatus() {
        return sessionStorage.getItem("sevencrm_upsell_completed") === "true";
    },

    get currentUpsellId() {
        return this.upsellConfig[this.step - 1];
    },

    get isLastStep() {
        return this.step === this.upsellConfig.length;
    },

    get hasError() {
        return !!this.error;
    },

    get shouldShowFlow() {
        return !this.hasCompletedFlow && !this.showThankYou;
    },

    clearError() {
        this.error = null;
    },

    resetFlow() {
        this.step = 1;
        this.loading = false;
        this.error = null;
        this.showThankYou = false;
        this.hasCompletedFlow = false;
        // Clear the completion status
        sessionStorage.removeItem("sevencrm_upsell_completed");
    },
}));
